import {useHttp} from "./http.hook";
import {CountryExchange} from "../shared/countryExchange";
import {Candle, IAnalytics, IDiversificationGroupsByTickers, TimeFrames, TradeAction} from "../shared/types";

interface IDataStatus {
  message: string,
  info: boolean
}

interface IDataCountryAdvisors {
  message: string,
  info: null | CountryExchange
}

interface IDataSetAdvisors {
  message: string,
}

interface IDataTickers {
  message: string,
  info: string[]
}

interface IDataRecommendations {
  message: string,
  info: Record<TradeAction, Partial<Record<string, [string[]]>>>//объект - TradeAction[ключ стратегии][массив рекомендаций]
}

interface IDataAnalytics {
  message: string,
  info: IAnalytics
}

interface IDataDiversificationGroups {
  message: string,
  info: IDiversificationGroupsByTickers
}

interface IDataQuotes {
  message: string,
  info: Record<string, Record<TimeFrames, Candle[]>>//объект графиков - <Record<тикер: string, Record<TimeFrames, Candle[]>>>
}

export const useAdvisors = () => {

  const {loading, request, error, clearError} = useHttp()

  //получение статуса работы советника
  const getStatusAdvisors = async () => {
    try {
      const data: IDataStatus = await request('/api/advisors/get-status', 'POST', {})
      return data
    } catch (e) {
      throw new Error('Ошибка получения данных.')
    }
  }

  //получение страны рынка по которому работает советник
  const getCountryWorkingAdvisors = async () => {
    try {
      const data: IDataCountryAdvisors = await request('/api/advisors/get-country-advisors', 'POST', {})
      return data
    } catch (e) {
      throw new Error('Ошибка получения данных.')
    }
  }

  //смена страны рынка по которому работает советник
  const setCountryWorkingAdvisorsToServer = async (country: CountryExchange) => {
    try {
      const data: IDataSetAdvisors = await request('/api/advisors/set-country-advisors', 'POST', {
        country: country,
      })
      return data
    } catch (e) {
      throw new Error('Ошибка сохранения данных.')
    }
  }

  //смена статуса работы советника
  const setStatusAdvisorsToServer = async (status: boolean) => {
    try {
      const data: IDataSetAdvisors = await request('/api/advisors/set-status', 'POST', {
        status: status,
      })
      return data
    } catch (e) {
      throw new Error('Ошибка сохранения данных.')
    }
  }

  //получение статуса вкл/выкл уведомлений от советников
  const getStatusNotifications = async () => {
    try {
      const data: IDataStatus = await request('/api/advisors/get-status-notifications', 'POST', {})
      return data
    } catch (e) {
      throw new Error('Ошибка получения данных.')
    }
  }

  //смена статуса вкл/выкл уведомлений от советников
  const setStatusNotifications = async (status: boolean) => {
    try {
      const data: IDataSetAdvisors = await request('/api/advisors/set-status-notifications', 'POST', {
        status: status,
      })
      return data
    } catch (e) {
      throw new Error('Ошибка сохранения данных.')
    }
  }

  //получение статуса вкл/выкл уведомлений о моих сигналах у подписчиков
  const getStatusNotificationsToCustomers = async () => {
    try {
      const data: IDataStatus = await request('/api/advisors/get-status-notifications-to-customers', 'POST', {})
      return data
    } catch (e) {
      throw new Error('Ошибка получения данных.')
    }
  }

  //смена статуса вкл/выкл уведомлений о моих сигналах у подписчиков
  const setStatusNotificationsToCustomers = async (status: boolean) => {
    try {
      const data: IDataSetAdvisors = await request('/api/advisors/set-status-notifications-to-customers', 'POST', {
        status: status,
      })
      return data
    } catch (e) {
      throw new Error('Ошибка сохранения данных.')
    }
  }

  //получение уже не входящих в snp500, но по которым есть позиции
  const getTickersWithPositionsNotInSAndP = async () => {
    try {
      const data: IDataTickers = await request('/api/advisors/get-tickers-with-positions-not-in-sp', 'POST', {})
      return data
    } catch (e) {
      throw new Error('Ошибка получения данных.')
    }
  }

  //получение рекомендаций от советника советника
  const getRecommendationsFromAdvisors = async () => {
    try {
      const data: IDataRecommendations = await request('/api/advisors/get-recommendations', 'POST', {})
      return data
    } catch (e) {
      throw new Error('Ошибка получения данных.')
    }
  }

  //получение групп диверсификации от советника
  const getDiversificationGroupsFromAdvisors = async () => {
    try {
      const data: IDataDiversificationGroups = await request('/api/advisors/get-market-sectors', 'POST', {})
      return data
    } catch (e) {
      throw new Error('Ошибка получения данных.')
    }
  }

  //получение рекомендаций от советника советника
  const getAnalyticsFromAdvisors = async () => {
    try {
      const data: IDataAnalytics = await request('/api/advisors/get-analytics-from-advisors', 'POST', {})
      return data
    } catch (e) {
      throw new Error('Ошибка получения данных.')
    }
  }

  //получения графиков с сервера
  const getQuotesFromAdvisors = async () => {
    try {
      const data: IDataQuotes = await request('/api/advisors/get-quotes-from-advisors', 'POST', {})
      return data
    } catch (e) {
      throw new Error('Ошибка получения данных.')
    }
  }

  return {
    loading,
    getStatusAdvisors,
    getCountryWorkingAdvisors,
    setCountryWorkingAdvisorsToServer,
    setStatusAdvisorsToServer,
    getTickersWithPositionsNotInSAndP,
    getStatusNotifications,
    setStatusNotifications,
    getStatusNotificationsToCustomers,
    setStatusNotificationsToCustomers,
    getRecommendationsFromAdvisors,
    getDiversificationGroupsFromAdvisors,
    getAnalyticsFromAdvisors,
    getQuotesFromAdvisors,
    error,
    clearError
  }
}
